export default __webpack_public_path__ + "static/media/APT.82870b88.svg";